module.exports = __webpack_public_path__ + "img/tick_grey.7f404d47.svg";